import { Rs } from './Rs';

class UserCertExam extends Rs {
    constructor() {
        super();
        this.baseUrl += '/userCertExam';
    }

    data({ userName, fullName, userStatus, remarks, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            userName,
            fullName,
            userStatus,
            remarks,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    save({ id, userId, isAvailable, remarks, userCertExamJson } = {}) {
        return super.post('/save', {
            id,
            userId,
            isAvailable,
            remarks,
            userCertExamJson,
        });
    }
}

export default new UserCertExam();
export { UserCertExam };
